export default __webpack_public_path__ + "static/media/reqPend.409778ca.svg";